import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Button } from '@softwaredev_cegeka/stix-core'
import { Modal } from '@softwaredev_cegeka/stix-modal'

class ConfirmDeleteModal extends Component {
    static propTypes = {
        title: PropTypes.string.isRequired,
        body: PropTypes.string.isRequired,
        show: PropTypes.bool.isRequired,
        handleClose: PropTypes.func.isRequired,
        handleDelete: PropTypes.func.isRequired,
    }

    render() {
        const { title, body, show, handleDelete, handleClose } = this.props

        return (
            <Modal show={show} onHide={handleClose} centered size="md">
                <Modal.Header closeButton>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{body}</Modal.Body>
                <Modal.Footer align={'left'}>
                    <Button variant="secondary" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={handleDelete}>
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default ConfirmDeleteModal
